import images from './images';

const Menu = [
    {
        text: 'Company',
        link: '#home',
    },
    {
        text: 'Capabilities',
        link: '#capabilities',
    },
    {
        text: 'Approach',
        link: '#approach',
    }
];
const ProductMenu = [
    {
        group: 'Data + AI',
        products: [
            {
                name: 'Dataface.ai',
                description: 'Active product for enterprise data-to-AI workflows',
                link: '#dataface',
            },
        ],
    },
    {
        group: 'Emerging AI',
        products: [
            {
                name: 'Voice AI',
                description: 'Research track',
                link: '#capabilities',
            },
            {
                name: 'Physical AI',
                description: 'Research track',
                link: '#capabilities',
            },
        ],
    },
];
const ServicesData = [
    {
        eyebrow: 'Data + AI initiative',
        title: 'Dataface.ai product systems',
        description: 'Design and ship enterprise data-to-AI workflows with governance, observability, and product-grade user experience.',
        link: '#dataface',
        itemclass: 'service-card-primary',
        imgURL: images.services01,
        points: ['Enterprise data workflows', 'AI-ready interfaces', 'Governed product releases'],
    },
    {
        eyebrow: 'Deeptech systems',
        title: 'Applied AI product platforms',
        description: 'Build model-backed platforms that connect data, reasoning, evaluation, and human-in-the-loop operations.',
        link: '#quote',
        itemclass: 'service-card-neutral',
        imgURL: images.services02,
        points: ['LLM orchestration', 'Evaluation pipelines', 'Human review loops'],
    },
    {
        eyebrow: 'Enterprise trust',
        title: 'AI governance and benchmarks',
        description: 'Create repeatable benchmarks, quality gates, and security checks before models move into business-critical paths.',
        link: '#approach',
        itemclass: 'service-card-ink',
        imgURL: images.services06,
        points: ['Prompt and model tests', 'Risk controls', 'Production scorecards'],
    },
    {
        eyebrow: 'Research lane',
        title: 'Voice AI and physical AI readiness',
        description: 'Explore voice-first agents and physical-world AI systems while the Data + AI initiative ships first.',
        link: '#quote',
        itemclass: 'service-card-warm',
        imgURL: images.services03,
        points: ['Voice workflows', 'Sensor-aware systems', 'Research-to-product planning'],
    },
]
const CaseStudies = [
    {
        title: 'Enterprise knowledge activation',
        text: 'Turn scattered data and documents into searchable, governed AI experiences for business teams.',
        link: '#quote',
        label: 'Discuss use case',
    },
    {
        title: 'LLM benchmark operations',
        text: 'Evaluate model quality, latency, safety, and cost before enterprise teams rely on AI in daily workflows.',
        link: '#approach',
        label: 'View approach',
    },
    {
        title: 'Data-to-product acceleration',
        text: 'Use Dataface.ai within the Data + AI initiative to make discovery, enrichment, and AI workflows easier to operationalize.',
        link: '#dataface',
        label: 'Explore Dataface.ai',
    }
];

const WorkingProcess = [
    {
        title: 'Identify the enterprise workflow',
        description: 'Map the business decision, data sources, users, risks, and measurable outcome before selecting models or tooling.',
    },
    {
        title: 'Design the AI product architecture',
        description: 'Define the product surface, data contracts, model orchestration, permissions, evaluation plan, and deployment path.',
    },
    {
        title: 'Prototype with measurable gates',
        description: 'Build a thin, testable version of the workflow and compare results against quality, safety, cost, and latency targets.',
    },
    {
        title: 'Engineer production readiness',
        description: 'Harden the system with observability, data validation, access control, fallbacks, and documented operating procedures.',
    },
    {
        title: 'Launch with governance',
        description: 'Ship the product with human review paths, audit-friendly benchmarks, release notes, and ownership for model changes.',
    },
    {
        title: 'Improve continuously',
        description: 'Track product usage, model drift, feedback, and operating cost so each release improves reliability and business value.',
    },

];

const Team = [];

const Testimonials = [];

const siteData = { Menu, ProductMenu, CaseStudies, WorkingProcess, Team, Testimonials, ServicesData };

export default siteData;
